import { z } from "zod";

import { AdvertisementType } from "@/client";
import i18n from "@/i18n";

const createAdvertisementSchema = z.object({
  name: z.string().min(1, i18n.t("validation.advertisementNameRequired")).trim(),
  type: z.nativeEnum(AdvertisementType),
  image: z.object({
    id: z.string().min(1, i18n.t("validation.advertisementImageRequired")),
    url: z.string(),
  }),
});

type CreateAdvertisementFormData = z.infer<typeof createAdvertisementSchema>;

export { createAdvertisementSchema };
export type { CreateAdvertisementFormData };